import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, ViewChild } from '@angular/core';
import { OrdersListComponent } from './orders-list/orders-list.component';
import { OrderTypes } from '../core/enums';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { DeliveryOrderStatuses } from '../../../core/enums';
import { IOrderStatusCounts } from '../../../core/interfaces';

@Component({
    selector: 'app-orders',
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrdersComponent implements OnDestroy {

  @ViewChild('listComponent') listComponent: OrdersListComponent;

  public selectedOrderType = OrderTypes.MIXED;
  public readonly orderTypes = OrderTypes;
  public selectedDocumentKeys: string[] = [];
  public countsReady = false;
  public statusCounts: IOrderStatusCounts = {
    open: 0,
    partlyFinished: 0,
    finished: 0,
    canceled: 0,
  };
  public readonly statusKeys: Array<keyof typeof DeliveryOrderStatuses> = [
    'Open',
    'PartlyFinished',
    'Finished',
    'Canceled',
  ];
  public readonly deliveryOrderStatuses = DeliveryOrderStatuses;

  private readonly _sub$: Subscription;

  public constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _cdr: ChangeDetectorRef,
  ) {
    this._sub$ = this._activatedRoute.queryParams.subscribe(param => {
      this.selectedOrderType = param['orderType'] && OrderTypes[param['orderType']]
        ? param['orderType']
        : OrderTypes.MIXED;
      this.selectedDocumentKeys = [];
      this.countsReady = false;
      this._cdr.markForCheck();
    });
  }

  public get pageTitle(): string {
    switch (this.selectedOrderType) {
      case OrderTypes.Bagable:
        return 'Bestellungen - Eigenmarke';
      case OrderTypes.NonPacking:
        return 'Bestellungen - Fremdmarke';
      default:
        return 'Bestellungen';
    }
  }

  public get countsSum(): number {
    return (this.statusCounts.open ?? 0)
      + (this.statusCounts.partlyFinished ?? 0)
      + (this.statusCounts.finished ?? 0)
      + (this.statusCounts.canceled ?? 0);
  }

  public get headerSubtitle(): string {
    return this.countsReady ? `${this.countsSum} Bestellungen` : null;
  }

  public countFor(key: keyof typeof DeliveryOrderStatuses): number {
    switch (key) {
      case 'Open':
        return this.statusCounts.open;
      case 'PartlyFinished':
        return this.statusCounts.partlyFinished;
      case 'Finished':
        return this.statusCounts.finished;
      case 'Canceled':
        return this.statusCounts.canceled;
      default:
        return 0;
    }
  }

  public onSelectedDocumentKeysChange(keys: string[]): void {
    this.selectedDocumentKeys = keys;
    this._cdr.markForCheck();
  }

  public onStatusCountsChange(counts: IOrderStatusCounts): void {
    this.statusCounts = counts;
    this.countsReady = true;
    this._cdr.markForCheck();
  }

  public ngOnDestroy(): void {
    this._sub$?.unsubscribe();
  }
}
